'use client'

import {useBlock} from '@local/hooks'
import {ReactNode, ElementType, useRef, forwardRef, useCallback, CSSProperties} from 'react'

export interface BlockProps {
	children: ReactNode;
	className?: string;
	type?: string;
	isDark?: boolean;
	as?: ElementType;
	style?: CSSProperties
	id?: string
}

export const Block = forwardRef(({children, className, as: Tag = 'section', isDark = false, type, style, id}: BlockProps, ref) => {
	const localRef = useRef<HTMLElement>()
	useBlock(localRef, isDark)

	const setRefs = useCallback((node) => {
		localRef.current = node
		if (ref) ref.current = node
	}, [])

	return (
		<Tag
			id={id}
			ref={setRefs}
			className={className}
			style={style}
			data-type={process.env.NODE_ENV === 'development' && type}>
			{children}
		</Tag>
	)
})
